import axiosInstance from './axiosConfig';

// ✅ Create support ticket
export const createSupportTicket = (formData) => {
  return axiosInstance.post('/support_tickets', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// ✅ Get support tickets
export const supportTickets = async () => {
  const response = await axiosInstance.get('/support_tickets');
  return response.data;
};

// ✅ Close support ticket
export const closeSupportTicket = async (ticketId) => {
  const response = await axiosInstance.patch(`/support_tickets/${ticketId}/close_ticket`, {
    support_ticket: {
      status: 'closed',
    },
  });
  return response.data;
};

// ✅ Submit review for closed ticket
export const submitSupportReview = async (payload) => {
  const {rating, comment, ticket_id} = payload;
  const response = await axiosInstance.post(`/support_tickets/${ticket_id}/submit_review`, {
    review: {
      rating,
      comment,
    },
  });
  return response.data;
};

// ✅ satisfection support ticket
export const updateSupportTicketStatus = async (ticketId) => {
  const response = await axiosInstance.patch(`/support_tickets/${ticketId}/satisfied`, {
    support_ticket: {
      satisfaction: 'no',
    },
  });
  return response.data;
};

